import type { PlatformAdapter, PlatformName } from './adapter';
import { pickAdapter } from './factory';

export type {
  PlatformAdapter,
  PlatformName,
  PlatformCapabilities,
  PlatformEvent,
} from './adapter';
export { pickAdapter };

// Vite replaces `import.meta.env.VITE_PLATFORM` at build time per --mode.
// In non-Vite contexts (e.g., Vitest), default to 'standalone'.
const envPlatform =
  (typeof import.meta !== 'undefined' &&
    (import.meta as unknown as { env?: { VITE_PLATFORM?: string } }).env?.VITE_PLATFORM) ??
  'standalone';

export const platform: PlatformAdapter = pickAdapter(envPlatform as PlatformName);
